import { ReloadGuardDirective } from './directives/reload-guard.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { SectionsModule } from './sections/sections.module';
import { CoreModule } from '../core/core.module';
import { PopupsModule } from './popups/popups.module';


const SharedList = [
  ComponentsModule,
  CoreModule,
  SectionsModule,
  PopupsModule
]

@NgModule({
  declarations: [ReloadGuardDirective],
  imports: [
    CommonModule,
    SharedList
  ],
  exports: [
    ReloadGuardDirective,
    SharedList
  ]
})
export class SharedModule { }
